import { render, staticRenderFns } from "./ship-map-set-area.vue?vue&type=template&id=6b443bf2&scoped=true"
import script from "./ship-map-set-area.vue?vue&type=script&lang=js"
export * from "./ship-map-set-area.vue?vue&type=script&lang=js"
import style0 from "./ship-map-set-area.vue?vue&type=style&index=0&id=6b443bf2&prod&lang=less&rel=stylesheet%2Fless&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b443bf2",
  null
  
)

export default component.exports